export const carSlider = () => {
  $(function () {
    $(".js_slide_for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: ".js_slide_nav",
      autoplay: true,
      autoplaySpeed: 5000,
    });
    $(".js_slide_nav").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: ".js_slide_for",
      focusOnSelect: true,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
    });
  });
};
